import React from "react"; 
import { useQueryParams } from "../../hooks/useQueryParams";

const Tabs = ({ tabKey = "tab", tabs = [], showCount, allCounts, className, tabClass }) => {
  const { query, setQueryParam } = useQueryParams();

  const activeValue = query[tabKey] || tabs[0]?.value; 
  
  const handleTabClick = (tab) => {
    if (tab.onClick) {
      tab.onClick();
    } else {
      setQueryParam(tabKey, tab.value);
    }
  };

  return (
    <div className={`flex gap-2 bg-[#F1F4FB] p-1 rounded-md ${className}`}>
      {tabs.map((tab) => {
        const isActive = activeValue === tab.value;
        return (
          <button
            key={tab.value}
            onClick={() => handleTabClick(tab)}
            disabled={tab.disabled}
            className={`px-4 py-3 rounded-md text-base font-medium transition disabled:opacity-75 disabled:cursor-not-allowed ${
              isActive
                ? "bg-web-blue text-white"
                : "text-black hover:bg-gray-200"
            } ${tabClass}`}
          >
            {tab.label}{showCount && ` - ${allCounts[tab.value] || 0}`}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
